import { appointmentIndexValidate } from '../../application/dtos/appointment_index_validate'

export class AppointmentIndexEntity {
    constructor({ id, arrival_date, container_number, description, commentary, status, files_status, is_national, already_picked, show_aduana, client, user, operation, warehouse }){
        this.id = id;
        this.arrival_date = arrival_date;
        this.container_number = container_number;
        this.description = description;
        this.commentary = commentary;
        this.status = status;
        this.files_status = files_status;
        this.is_national = is_national;
        this.already_picked = already_picked;
        this.show_aduana = show_aduana;
        this.client = client;
        this.user = user;
        this.operation = operation;
        this.warehouse = warehouse;
    }

    isValid() {
        return appointmentIndexValidate(this);
    }
}